import { useNavigate } from "react-router-dom";
import { Swords, ArrowLeft, Mail } from "lucide-react";

export default function Contact() {
  const navigate = useNavigate();
  return (
    <div data-testid="contact-page" className="min-h-screen bg-zinc-950 flex flex-col">
      <header className="border-b border-amber-900/30 bg-zinc-900/40">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <button data-testid="contact-back-btn" onClick={() => navigate("/")}
            className="flex items-center gap-2 text-zinc-400 hover:text-amber-300 transition-colors text-sm">
            <ArrowLeft size={16} /> Back
          </button>
          <div className="flex items-center gap-2.5">
            <Swords className="text-amber-500" size={18} />
            <span className="font-cinzel text-sm tracking-[0.25em] uppercase text-amber-300">Lanista — Gladiator Manager</span>
          </div>
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-lg w-full text-center">
          <div className="mx-auto mb-6 w-14 h-14 flex items-center justify-center rounded-full border border-amber-700/40 bg-amber-950/20">
            <Mail className="text-amber-400" size={26} />
          </div>
          <h1 className="font-cinzel text-3xl sm:text-4xl uppercase tracking-wide text-amber-300 mb-4">Contact Us</h1>
          <p className="text-zinc-400 text-base leading-relaxed mb-8">
            Have a question, feedback, or need help with your ludus? For any inquiries, reach out to us and
            we'll get back to you as soon as we can.
          </p>
          <a data-testid="contact-email-link" href="mailto:admin@lanistamanager.com"
            className="inline-flex items-center gap-2 px-6 py-3 bg-amber-500 text-zinc-950 font-cinzel uppercase tracking-wide text-sm hover:bg-amber-400 rounded-sm transition-colors">
            <Mail size={16} /> admin@lanistamanager.com
          </a>
        </div>
      </main>
    </div>
  );
}
